import ActionTypeInfo from "./ActionTypeInfo";

export default ActionTypeInfo;